export default {
  SEND_MESSAGE:            'sendMessage',
  SET_SUGGESTED_QUESTIONS: 'setSuggestedQuestions',
  TOGGLE:                  'toggle',
};
